import Vue from "vue";
import Vuex from "vuex";
import users from "./modules/users";
import themes from "./modules/theme";
import colaboracoes_aprovadas from "./modules/colaboracoesAprovadas"
import colaboracoes_moderadas from "./modules/colaboracoesModeradas"
import producoes from "./modules/producoes";
import logs from "./modules/logs";
import moderacao from "./modules/moderacao";
import portais from "./modules/portais";
import noticias from "./modules/noticias";
import telas_descanso from './modules/teladescanso'
import contas_bloqueadas from './modules/contaBloqueada'
import palavras_bloqueadas from "./modules/palavraBloqueada";
import mosaico from "./modules/mosaico";
import pastas from "./modules/pastas";
import enquetes from "./modules/enquetes";
import cronometros from "./modules/cronometros";
import tarja from "./modules/tarja";
import tarja_enquete from "./modules/tarjaEnquete";
import tarja_cronometro from "./modules/tarjaCronometro";
import cameras from "./modules/cameras";
import globographics from "./modules/globographics";
import playout from "./modules/playout";
import playout_engines from "./modules/playoutEngines";
import sites from "./modules/sites";
import sites_admin from "./modules/sitesAdmin";

import createPersistedState from "vuex-persistedstate";
import pracas from "./modules/pracas";
import youtube from "./modules/youtube";
Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

export default new Vuex.Store({
  modules: {
    users,
    themes,
    colaboracoes_aprovadas,
    colaboracoes_moderadas,
    producoes,
    contas_bloqueadas,
    logs,
    moderacao,
    portais,
    noticias,
    telas_descanso,
    palavras_bloqueadas,
    mosaico,
    pastas,
    enquetes,
    cronometros,
    tarja,
    tarja_enquete,
    tarja_cronometro,
    cameras,
    pracas,
    youtube,
    globographics,
    playout,
    playout_engines,
    sites,
    sites_admin
  },
  plugins: [createPersistedState({ paths: ["users", "colaboracoes_moderadas"] })],
  strict: debug,
});
